import { Skeleton } from '@/components/skeleton/skeleton'

import { cn } from '@/lib/utils'

export const LoadingSkeleton = () => {
  return (
    <div className={cn('flex flex-col gap-y-7')}>
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
    </div>
  )
}

const SkeletonRow = () => {
  return (
    <div className={cn('flex gap-x-3')}>
      <div className={cn('flex items-center')}>
        <Skeleton className={cn('w-[40px]', 'h-[40px]', 'rounded-[50%]')} />
      </div>
      <div className={cn('flex flex-1 flex-col gap-y-2')}>
        <Skeleton className={cn('w-full', 'h-[24px]')} />
        <Skeleton className={cn('w-full', 'h-[20px]')} />
      </div>
    </div>
  )
}
